/*
 * @Author: gaobin
 * @Date: 2025-03-19 14:12:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-03-26 15:25:41
 * @Description: 支付
 */
const paymentMap = {
  // 获取转账银行卡信息(转账银行、银行卡信息)
  getBackCardExt: '/usb/uwb-app/api/v1/pay/getBackCard',
  // 线下支付
  payPaymentExt: '/usb/uwb-app/api/v1/pay/payment',
  // 线上支付
  // payOnlinePaymentExt: '/pdpd/hello/pay/goPay',
  payOnlinePaymentExt: '/usb/uwb-app/api/v1/apy/goPay',

  // 支付白名单(是否展示线上支付)
  getPayWhiteList: '/usb/uwb-app/api/getPayWhiteList',
};

export default paymentMap;
